/**
 * @file 权限配置
 * @author jiangjun
 */
export default {
    // //首页
    // home: {
    //     moduleNumber: 1,
    //     list: 1,
    // },
    workBreah: {
        moduleNumber: 1,
        myProcess: 13,
        processList: 14,
        processDetail: 16,
    },
    // halfyear: {
    //     moduleNumber: 2,
    //     // halfManage: 2,
    //     list: 3,
    // },
    year: {
        moduleNumber: 4,
        alterYearBudgetApply: 5,
        budgetDetailList: 7,
        satrtBudget: 15,
        budgetControl: 38,
    },
    system: {
        moduleNumber: 8,
        user: 9,
        role: 10,
        menu: 11,
        departmentSelect: 21,
    },
    accountingTitle: {
        moduleNumber: 17,
        list: 18
    },
    actualDataManage: {
        moduleNumber: 19,
        list: 20
    },
    businessBudget: {
        moduleNumber: 22,
        budgetDetail: 23, // 业务预算明细
        departmentSelect: 24, // 部门类型设置
        expenseName: 25, // 费用名称管理
        personInCharge: 26, // 归口人管理
        operateLog: 27, // 操作日志
    },
    budgetReport: {
        moduleNumber: 28, // 
        summary: 29, // 总表
        schoolByCategory: 30, // 分校按大类
        schoolByDetail: 31, // 分校按明细
        headquarterByCategory: 32, // 总部职能按大类
        headquarterByDept: 33, // 总部职能按部门
        productLine: 34, // 产品线
        reportByDept: 35, // 报告-按部门
        reportByHost: 36, // 报告-按归口
        reportByProductLine: 37, // 报告-按产品线
    },
}
